export const F = "'Fredoka', sans-serif";
export const N = "'Nunito', sans-serif";
export const L = "'Literata', serif";
